import { SearchBody } from '../types/search-body.types';

export function convertToGetSearchQueryString<TFilters>(body: Partial<SearchBody<TFilters>>) {
  const bodyFilters = body?.filters ? Object.entries(body.filters) : [];
  const pagingInfo = [
    ['pageNum', body?.paging?.current],
    ['pageSize', body?.paging?.size],
  ];
  const sortFields = body?.sortFields?.length
    ? [['sortFields', body.sortFields.map((sf) => `${sf.field}:${sf.order}`).join(',')]]
    : [];
  const keyValuePairs = [...bodyFilters, ...pagingInfo, ...sortFields]
    .filter(([, v]) => !!v || v === 0)
    .map(([k, v]) => `${k}=${v}`);

  return [`query=${body.query}`, ...keyValuePairs].join('&');
}
